import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content-floorplan-house" }
const _hoisted_2 = {
  key: 0,
  class: "content-floorplan"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content-slider-facades" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass(["dropdown-button open-slider", { active: $setup.fadeInEffect.floorplan }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleSection($setup.BuilderToggleDropdown.FLOORPLAN)))
      }, "Floorplan", 2),
      ($setup.sectionStates.floorplan)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "floorplan",
              src: $props.houseInfo?.floorplans[0]?.url
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: _normalizeClass(["dropdown-button open-slider", { active: $setup.fadeInEffect.facade }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleSection($setup.BuilderToggleDropdown.FACADE)))
      }, "Facade Options", 2),
      _createVNode($setup["BuilderSliderMobile"], {
        selectedHouseDesign: $setup.props.houseInfo,
        isOpen: $setup.sectionStates.facade,
        "onUpdate:selectedFacade": $setup.onUpdateSelectedFacade
      }, null, 8, ["selectedHouseDesign", "isOpen"])
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["dropdown-button open-slider", { active: $setup.fadeInEffect.dimensions }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleSection($setup.BuilderToggleDropdown.DIMENSIONS)))
    }, "Area, Dimensions and Design Features", 2),
    _createVNode($setup["HouseDimensionsAndInclusions"], {
      houseInfo: $props.houseInfo,
      isDimensionsOpen: $setup.sectionStates.dimensions
    }, null, 8, ["houseInfo", "isDimensionsOpen"]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "spacing" }, null, -1)),
    _createElementVNode("button", {
      class: _normalizeClass(["dropdown-button open-slider", { active: $setup.fadeInEffect.inclusions }]),
      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleSection($setup.BuilderToggleDropdown.INCLUSIONS)))
    }, "Inclusions", 2),
    _createVNode($setup["HouseDimensionsAndInclusions"], {
      houseInfo: $props.houseInfo,
      isInclusionsOpen: $setup.sectionStates.inclusions
    }, null, 8, ["houseInfo", "isInclusionsOpen"])
  ], 64))
}